


import useTranslations from "../../providers/useTranslations";
import { invertColor } from "../utils";

function CollapsibleCategory(props) {
  const { category, title, onSelected } = props

  const [isExpanded, setExpanded] =React.useState(false)

  if (category.Categories != null && category.Categories.length > 0) {

    let categories = category.Categories
    // sort categories by the sequence number
  categories.sort((a, b) => a.sequence - b.sequence)

    return (
      <div className="collapsible-element pl-3 py-2 mr-2"   >
        <div className="space-between collapsible-item-title"><span onClick={() => {
          setExpanded(false)
          onSelected(category)
        }} >{title}</span>
          <i className="fa fa-caret-down fa-2x" onClick={() => setExpanded((x) => !x)}></i>
        </div>
        {isExpanded && categories.map((category, index) => {

          return (
            <CollapsibleCategory
              key={`category_${category.name}`}
              category={category}
              title={category.name}
              onSelected={onSelected}
            >
            </CollapsibleCategory>
          )
        }
        )


        }

      </div>
    )
  }

  return (
    <div className="collapsible-element pl-3 py-2" onClick={() => {
      setExpanded(false)
      onSelected(category)
    }}  >
      <div className="collapsible-item-title" ><span >{title}</span>

      </div>

    </div>
  )
}

function CategorySelector(props) {
  const { categories, menu, onSelected } = props

  const [isExpanded, setExpanded] =React.useState(false)
  const { tr, trmap, getTranslations /* , , locale, translations, setLocale */ } = useTranslations();

  const contentList = (categories) => {
    if (isExpanded) {
      return <div className="category-content-list">
        {categories.map((category, index) => {

          return (
            <CollapsibleCategory
              key={`category_${category.name}`}
              category={category}
              title={category.name}
              onSelected={onSelected}
            >
            </CollapsibleCategory>
          )
        }
        )
        }
      </div>
    }
    return <div></div>
  }

  // default black background with white text
  let style = {
    backgroundColor: 'white',
    color: 'black'
  }

  if (menu.colour && menu.colour != "") {
    style.backgroundColor = invertColor(menu.colour, true)
    style.color = menu.colour
  }

  // sort categories by the sequence number
  categories.sort((a, b) => a.sequence - b.sequence)

  return (
    <div className=" category-selector py-2" >
      <div className=" category-selector-header "

        onClick={() => setExpanded((x) => !x)}>

        <h4  >{tr("Categories")}</h4>
        <i className="fa fa-caret-down fa-2x"></i>
      </div>
      {contentList(categories)}
    </div>
  )
}

export default CategorySelector;